import React, {Component} from 'react';
import Raven from 'raven-js';
import store from 'store';

import {
    Button,
    Card,
    Col,
    Container,
    Row,
} from 'reactstrap';
import {Link} from 'react-router';

import brokenLink from '../../assets/svg/broken-link.svg';
import whiteLogo from '../../assets/svg/logo.svg';

class ErrorBrokenLink extends Component {
    state = {
        canSubmit: false,
        broken: false
    };

    componentWillMount() {
        document.body.classList.toggle('dark-background', true);
        Raven.captureMessage('Invalid URL', {
            level: 'warning'
        });
    }

    componentWillUnmount() {
        document.body.classList.remove('dark-background');
    }

    render() {

        const returnLink = store.get('access_token') ? '/dashboard/' : '/login/';

        return (
            <Container style={{display: 'flex', justifyContent: 'center'}}>
                <Row>
                    <Col>
                        <img className="login-logo" width="80%" src={whiteLogo} alt="PolyRents"/>
                        <Card style={{maxWidth: '345px', margin: 'auto', padding: '1em'}}>
                            <div className="center">
                                <img className={this.state.broken && 'animated hinge'}
                                     width="50%"
                                     style={{margin: '1em'}}
                                     src={brokenLink}
                                     onClick={() => this.setState({broken: true})}
                                     alt="Map"/>
                                <h2>Hmmm</h2>
                                <p>It looks like that link is invalid or expired</p>
                                <br/>
                                <Button color="success"
                                        tag={Link} to={returnLink}
                                        style={{textAlign: 'center', margin: 'auto', display: 'block'}}
                                >
                                    Take me home!
                                </Button>
                                <br/>
                                <p>
                                    <small>If you think this is an error, please <a href="https://help.polyrents.com/">contact us</a> for help.</small>
                                </p>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ErrorBrokenLink;



// WEBPACK FOOTER //
// ./src/containers/errors/ErrorBrokenLink.js